import type {PropsWithChildren} from 'react'
import type {ConversationConnection} from './utils/interleave-commits'
import styles from './CommitDisclosure.module.css'

interface CommitConnectedCommentProps {
  connection?: ConversationConnection
}

export function CommitConnectedComment({children, connection}: PropsWithChildren<CommitConnectedCommentProps>) {
  return (
    <div className={styles.CommentConnection} data-commit-connection={connection} data-testid="timeline-comment">
      {children}
    </div>
  )
}
